export default __webpack_public_path__ + "static/media/logo06.51d765f5.svg";